import * as tslib_1 from "tslib";
import selectInlinePreviewsOption from '../actions/selectInlinePreviewsOption';
import store from '../store/store';
import { getFallbackValueIfNull } from 'owa-options-core';
import { ChoiceGroup } from 'office-ui-fabric-react/lib/ChoiceGroup';
import { getUserConfiguration } from 'owa-session-store';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { reactive } from 'satcheljs/lib/legacy/react';
var InlinePreviewsFull = /** @class */ (function (_super) {
    tslib_1.__extends(InlinePreviewsFull, _super);
    function InlinePreviewsFull() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (ev, option) {
            selectInlinePreviewsOption(option.key === 'true');
        };
        return _this;
    }
    InlinePreviewsFull.prototype.render = function () {
        var _a = this.props, optionStore = _a.optionStore, userOptions = _a.userOptions;
        var isPreviewsInlineEnabled = getFallbackValueIfNull(optionStore.isEnabled, userOptions.ShowInlinePreviews);
        return (React.createElement(ChoiceGroup, { selectedKey: "" + isPreviewsInlineEnabled, options: [
                {
                    key: 'true',
                    text: strings.options_inlinePreviews_enabled,
                },
                {
                    key: 'false',
                    text: strings.options_inlinePreviews_disabled,
                },
            ], onChange: this.onChange }));
    };
    InlinePreviewsFull = tslib_1.__decorate([
        reactive({
            optionStore: function () { return store; },
            userOptions: function () { return getUserConfiguration().UserOptions; },
        })
    ], InlinePreviewsFull);
    return InlinePreviewsFull;
}(React.Component));
export default InlinePreviewsFull;
//# sourceMappingURL=InlinePreviewsFull.js.map